import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from 'axios'
import { toast } from "react-toastify";

export const getSelectedChannel = createAsyncThunk(
    'integrate/getSelectedChannel',
    async ({ token }, { rejectWithValue }) => {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_BASE_URL}/channels/discord/selected`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            if (res.data.status) {
                return res.data;
            }
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);
export const getSelectedChannelSlack = createAsyncThunk(
    'integrate/getSelectedChannelSlack',
    async ({ token }, { rejectWithValue }) => {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_BASE_URL}/channels/slack/selected`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            if (res.data.status) {
                return res.data;
            }
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

export const prefrenceUpdateDiscord = createAsyncThunk(
    'integrate/updatePrefrenceDiscord',
    async ({ token, featPref, id }, { rejectWithValue }) => {
        try {
            const res = await axios.patch(
                `${process.env.REACT_APP_BASE_URL}/channels/discord/channel-preference/${id}`,
                { featPref },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            if (res.data.status) {
                return res.data
            }
        } catch (error) {
            return rejectWithValue(error.response?.data?.message);
        }
    }
)
export const prefrenceUpdateSlack = createAsyncThunk(
    'integrate/updatePrefrenceSlack',
    async ({ token, featPref, id }, { rejectWithValue }) => {
        try {
            const res = await axios.patch(
                `${process.env.REACT_APP_BASE_URL}/channels/slack/channel-preference/${id}`,
                { featPref },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            if (res.data.status) {
                return res.data
            }
        } catch (error) {
            return rejectWithValue(error.response?.data?.message);
        }
    }
)

export const setServer = createAsyncThunk(
    'integrate/setServer',
    async ({ token, selectedServer }, { rejectWithValue }) => {
        try {
            const res = await axios.patch(
                `${process.env.REACT_APP_BASE_URL}/connections/discord/set-server`,
                selectedServer,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            if (res.data.status) {
                toast.success("Connected to server successfully!")
                return res.data
            }
        } catch (error) {
            toast.error(error.response?.data?.message)
            return rejectWithValue(error.response?.data?.message);
        }
    }
)

export const deleteConnection = createAsyncThunk(
    'integrate/deleteConnection',
    async ({ token }, { rejectWithValue }) => {
        try {
            const res = await axios.delete(
                `${process.env.REACT_APP_BASE_URL}/connections/discord`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            if (res.data.status) {
                toast.success(res.data.message)
                return res.data
            }
        } catch (error) {
            toast.error(error.response?.data?.message)
            return rejectWithValue(error.response?.data?.message);
        }
    }
)

export const deleteConnectionSlack = createAsyncThunk(
    'integrate/deleteConnectionSlack',
    async ({ token }, { rejectWithValue }) => {
        try {
            const res = await axios.delete(
                `${process.env.REACT_APP_BASE_URL}/connections/slack`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            if (res.data.status) {
                toast.success(res.data.message)
                return res.data
            }
        } catch (error) {
            toast.error(error.response?.data?.message)
            return rejectWithValue(error.response?.data?.message);
        }
    }
)


export const checkConnections = createAsyncThunk(
    'integrate/checkConnections',
    async ({ token }, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/connections`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.data || typeof response.data.status === 'undefined' || !Array.isArray(response.data.response)) {
                return rejectWithValue('Invalid server response format');
            }

            if (!response.data.status || response.data.response.length === 0) {
                return {
                    discord: null,
                    slack: null,
                    message: 'No active connections found',
                };
            }
            const discordConnection = response.data.response.find(conn => conn.platform === 'discord') || null;
            const slackConnection = response.data.response.find(conn => conn.platform === 'slack') || null;

            return {
                discord: discordConnection,
                slack: slackConnection,
                lastUpdated: new Date().toISOString(),
            };

        } catch (error) {
            let errorMessage = 'Failed to check connections';
            if (error.response) {
                errorMessage = error.response.data?.message || error.response.statusText;
            } else if (error.request) {
                errorMessage = 'No response from server';
            }
            return rejectWithValue(errorMessage);
        }
    }
);

export const getChannelLIstDiscord = createAsyncThunk(
    'integrate/getChannelLIstDiscord',
    async ({ token, id }, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BASE_URL}/channels/discord/${id}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            if (response.data.status) {
                return response.data
            }
        } catch (error) {
            return rejectWithValue(error.response?.data?.message);
        }
    }
)

export const getChannelLIstSlack = createAsyncThunk(
    'integrate/getChannelLIstSlack',
    async ({ token, id }, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BASE_URL}/channels/slack`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            if (response.data.status) {
                return response.data
            }
        } catch (error) {
            return rejectWithValue(error.response?.data?.message);
        }
    }
)

export const saveChannelConfig = createAsyncThunk(
    'integrate/saveChannelsConfig',
    async ({ token, body }, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_BASE_URL}/channels/discord`,
                body,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            if (response.data.status) {
                toast.success("Channel saved with Discord preference!")
                return response.data
            }
        } catch (error) {
            toast.error(error.response?.data?.message)
            return rejectWithValue(error.response?.data?.message);
        }
    }
)

export const saveChannelSlack = createAsyncThunk(
    'integrate/saveChannelSlack',
    async ({ token, body }, { rejectWithValue }) => {
        try {
            const res = await axios.patch(
                `${process.env.REACT_APP_BASE_URL}/channels/slack`,
                body,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            if (res.data.status) {
                toast.success("Connected to Channel successfully!")
                return res.data
            }
        } catch (error) {
            toast.error(error.response?.data?.message)
            return rejectWithValue(error.response?.data?.message);
        }
    }
)

export const setChannelSlack = createAsyncThunk(
    'integrate/setChannelSlack',
    async ({ token, body }, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_BASE_URL}/channels/slack/join`,
                body,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            if (response.data.status) {
                toast.success("Channel save")
                return response.data
            }
        } catch (error) {
            toast.error(error.response?.data?.message)
            console.log(error.response?.data?.message || error?.response?.data?.response)
            return rejectWithValue(error.response?.data?.message || error?.response?.data?.response);
        }
    }
)

const integrateSlice = createSlice({
    name: 'integrate',
    initialState: {
        connections: { discord: null, slack: null },
        savedChannelConfig: { discord: null, slack: null },
        channelListDiscord: [],
        channelListSlack: [],
        selectedPlatformGlobal: null,
        externalIdDiscord: null,
        loading: false,
        error: null
    },
    reducers: {
        setSelectedPlatformGlobal: (state, action) => {
            state.selectedPlatformGlobal = action.payload;
        },
        setExternalIdGlobal: (state, action) => {
            console.log('reducer', action.payload)
            state.externalIdDiscord = action.payload
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(checkConnections.pending, (state) => {
                state.loading = true
            })
            .addCase(checkConnections.fulfilled, (state, action) => {
                state.loading = false
                state.connections = action.payload
            })
            .addCase(checkConnections.rejected, (state, action) => {
                state.loading = false
                state.connections = null
            })
            .addCase(getChannelLIstDiscord.pending, (state) => {
                state.loading = true
            })
            .addCase(getChannelLIstDiscord.fulfilled, (state, action) => {
                state.loading = false
                state.channelListDiscord = action.payload.response
            })
            .addCase(getChannelLIstDiscord.rejected, (state) => {
                state.loading = false
            })
            .addCase(getChannelLIstSlack.pending, (state) => {
                state.loading = true
            })
            .addCase(getChannelLIstSlack.fulfilled, (state, action) => {
                state.loading = false
                state.channelListSlack = action.payload.response
            })
            .addCase(getChannelLIstSlack.rejected, (state) => {
                state.loading = false
            })
            .addCase(saveChannelConfig.pending, (state) => {
                state.loading = true
            })
            .addCase(saveChannelConfig.fulfilled, (state) => {
                state.loading = false
            })
            .addCase(saveChannelConfig.rejected, (state) => {
                state.loading = false
            })
            .addCase(deleteConnection.pending, (state) => {
                state.loading = true
            })
            .addCase(deleteConnection.fulfilled, (state) => {
                state.loading = false
                state.connections = { ...state.connections, discord: null }
                state.savedChannelConfig = { ...state.savedChannelConfig, discord: null }
                state.channelListDiscord = []
            })
            .addCase(deleteConnection.rejected, (state) => {
                state.loading = false
            })
            .addCase(deleteConnectionSlack.pending, (state) => {
                state.loading = true
            })
            .addCase(deleteConnectionSlack.fulfilled, (state) => {
                state.loading = false
                state.connections = { ...state.connections, slack: null }
                state.savedChannelConfig = { ...state.savedChannelConfig, slack: null }
                state.channelListSlack = []
            })
            .addCase(deleteConnectionSlack.rejected, (state) => {
                state.loading = false
            })
            .addCase(setServer.pending, (state) => {
                state.loading = true
            })
            .addCase(setServer.fulfilled, (state) => {
                state.loading = false
            })
            .addCase(setServer.rejected, (state) => {
                state.loading = false
            })
            .addCase(getSelectedChannel.fulfilled, (state, action) => {
                state.savedChannelConfig = {
                    ...state.savedChannelConfig,
                    discord: action.payload.response
                };
            })
            .addCase(getSelectedChannel.rejected, (state, action) => {
                state.savedChannelConfig = {
                    ...state.savedChannelConfig,
                    discord: null
                };
            })
            .addCase(getSelectedChannelSlack.fulfilled, (state, action) => {
                state.savedChannelConfig = {
                    ...state.savedChannelConfig,
                    slack: action.payload.response
                };
            })
            .addCase(getSelectedChannelSlack.rejected, (state, action) => {
                state.savedChannelConfig = {
                    ...state.savedChannelConfig,
                    slack: null
                };
            })
            .addCase(saveChannelSlack.pending, (state) => {
                state.loading = true
            })
            .addCase(saveChannelSlack.fulfilled, (state) => {
                state.loading = false
            })
            .addCase(saveChannelSlack.rejected, (state) => {
                state.loading = false
            })
            .addCase(prefrenceUpdateDiscord.fulfilled, (state, action) => {
                toast.success(action.payload.response)
            })
            .addCase(prefrenceUpdateDiscord.rejected, (state, action) => {
                toast.error(action.payload)
            })
            .addCase(prefrenceUpdateSlack.fulfilled, (state, action) => {
                console.log(action)
                toast.success(action.payload.response)
            })
            .addCase(prefrenceUpdateSlack.rejected, (state, action) => {
                console.log(action)
                toast.error(action.payload)
            })
    }
})

export const { setSelectedPlatformGlobal, setExternalIdGlobal } = integrateSlice.actions

export default integrateSlice.reducer;